/* eslint-disable */
export default {
  sureToDeleteVoiceMail: 'Eliminare questo messaggio vocale?',
  sureToDeleteFax: 'Eliminare questo fax?',
  doNotAskAgain: 'Non chiedermelo più',
} as const;

// @key: @#@"sureToDeleteVoiceMail"@#@ @source: @#@"Are you sure you want to delete this voicemail?"@#@
// @key: @#@"sureToDeleteFax"@#@ @source: @#@"Are you sure you want to delete this fax?"@#@
// @key: @#@"doNotAskAgain"@#@ @source: @#@"Don't ask me again"@#@
